import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";

const clearAction = createAction("clear");
export const clearAppointmentDashboardCombinedFilter = createAction(
  "clearAppointmentDashboardCombinedFilter"
);

export interface FiltersState {
  status: { value: string; label: string }[];
  mainCategory: { value: string; label: string }[];
  executedBy: { value: string; label: string }[];
  assistedBy: { value: string; label: string }[];
  subject: { value: string; label: string }[];
  company: { value: string; label: string; companyId: string }[];
  isAnalog: { value: string; label: string } | null;
  includeCanceled: boolean;
}

const initialState: FiltersState = {
  status: [],
  mainCategory: [],
  executedBy: [],
  assistedBy: [],
  subject: [],
  company: [],
  isAnalog: null,
  includeCanceled: false,
};

const appointmentDashboardCombinedFilterSlice = createSlice({
  name: "appointmentDashboardCombinedFilterSlice",
  initialState,
  reducers: {
    setAppointmentDashboardCombinedFilter: (
      state,
      action: PayloadAction<{ name: keyof FiltersState; value: any }>
    ) => {
      const { name, value } = action.payload;
      let nextValue: any;

      if (Array.isArray(value)) {
        nextValue = [...value];
      } else {
        nextValue = value;
      }

      return {
        ...state,
        [name]: nextValue,
      };
    },

    resetAppointmentDashboardCombinedFilters: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(clearAction, () => {
      return initialState;
    });
    builder.addCase(clearAppointmentDashboardCombinedFilter, () => {
      return initialState;
    });
  },
});

export const {
  setAppointmentDashboardCombinedFilter,
  resetAppointmentDashboardCombinedFilters,
} = appointmentDashboardCombinedFilterSlice.actions;

export default appointmentDashboardCombinedFilterSlice.reducer;
